<template>
  <div>
    <div class="row g-2 align-items-end mb-3">
      <div class="col-md-4"><label class="form-label">From</label><input v-model="from" type="datetime-local" class="form-control form-control-sm"></div>
      <div class="col-md-4"><label class="form-label">To</label><input v-model="to" type="datetime-local" class="form-control form-control-sm"></div>
      <div class="col-md-2"><MaterialButton type="button" color="info" size="sm" :disabled="loading" @click="fetchStats">Refresh</MaterialButton></div>
    </div>
    <div v-if="loading" class="text-secondary">Loading report...</div>
    <template v-else>
      <div class="row g-3">
        <div v-for="card in cards" :key="card.label" class="col-6 col-md-3"><div class="card p-3 h-100"><small class="text-secondary">{{ card.label }}</small><strong class="fs-4">{{ card.value }}</strong></div></div>
      </div>
      <div class="row g-3 mt-1">
        <div class="col-md-6"><div class="card p-3"><h6>Email effectiveness</h6><div class="d-flex justify-content-between"><span>Delivery rate</span><strong>{{ emails.delivery_rate }}%</strong></div><div class="d-flex justify-content-between"><span>Open rate</span><strong>{{ emails.open_rate }}%</strong></div><div class="d-flex justify-content-between"><span>Click rate</span><strong>{{ emails.click_rate }}%</strong></div></div></div>
        <div class="col-md-6"><div class="card p-3"><h6>Lead pipeline</h6><div v-for="(count, status) in organizations" :key="status" class="d-flex justify-content-between"><span>{{ status.replaceAll('_', ' ') }}</span><strong>{{ count }}</strong></div></div></div>
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import MaterialButton from '@/components/common/MaterialButton.vue'
import api from '@/config/api'

function localInput(date) { const d = new Date(date); return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16) }
const from = ref(localInput(Date.now() - 86400000))
const to = ref(localInput(Date.now()))
const loading = ref(true)
const emails = ref({})
const organizations = ref({})
const cards = computed(() => [
  { label: 'Emails sent', value: emails.value.sent || 0 },
  { label: 'Delivered', value: emails.value.delivered || 0 },
  { label: 'Opened', value: emails.value.opened || 0 },
  { label: 'Clicked', value: emails.value.clicked || 0 },
  { label: 'Bounced', value: emails.value.bounced || 0 },
  { label: 'Failed', value: emails.value.failed || 0 },
  { label: 'Queued', value: emails.value.queued || 0 },
  { label: 'Organizations contacted', value: emails.value.organizations_contacted || 0 },
  { label: 'Unsubscribe actions', value: emails.value.unsubscribes || 0 },
  { label: 'Organizations signed up', value: emails.value.signed_up_organizations || 0 },
])

async function fetchStats() {
  loading.value = true
  try {
    const response = await api.get('/admin/leads/stats', { params: { from: new Date(from.value).toISOString(), to: new Date(to.value).toISOString() } })
    const output = response.data?.output || {}
    emails.value = output.emails || {}
    organizations.value = output.organizations_by_status || {}
  } catch (e) {
    console.error('Error fetching lead report:', e)
  } finally { loading.value = false }
}
onMounted(fetchStats)
</script>